<template>
  <!-- 仪器管理-仪器列表 -->
  <div class="equip-mana">
       <div class="rigth-item" style="min-width: 330px;display: flex;justify-content: end;">
        <div class="my-buttom select-buttom">
          <span @click="viewChange">
            视图切换
          </span>
          <el-divider direction="vertical"></el-divider>
          <el-popover placement="top-start" width="50" popper-class='tips' trigger="hover" content="设置默认视图">
            <i class="el-icon-setting" slot="reference" @click="setViewStatus"></i>
          </el-popover>
        </div>
        <div class="my-buttom select-buttom" @click="showModel(1)">
          {{
            yqVal == 1 ? "新增仪器" : yqVal == 2 ? "新增仪器组" : yqVal == 3 ? "新增固定式仪器" : "新增仪器"
          }}
        </div>
        <div class="my-buttom select-buttom" @click="handleClick(1)">
          异常处置
        </div>
      </div>
    <div class="head-list">
      <div class="left-item">
     
        <!-- <div class="my-buttom" :class="[yqVal == 0 ? 'select-buttom' : '']" @click="yqChange(0)">
          全部仪器
        </div> -->
        <div class="my-buttom" :class="[yqVal == 1 ? 'select-buttom' : '']" @click="yqChange(1)">
          仪器列表
        </div>
        <div class="my-buttom" :class="[yqVal == 2 ? 'select-buttom' : '']" @click="yqChange(2)">
          仪器组列表
        </div>
        <div class="my-buttom" :class="[yqVal == 3 ? 'select-buttom' : '']" @click="yqChange(3)" v-if="isOpenPower">
          固定式仪器
        </div>
        <div class="search-item">
          <el-input class="myinput" size="small" suffix-icon="el-icon-search" placeholder="请输入名称、编号或型号"
            v-model="searchForm.searchInfo"></el-input>
              <el-date-picker  size="small" style="width: 300px;" format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="searchForm.calibration"
                                type="daterange" range-separator="至" start-placeholder="下次检定开始日期" end-placeholder="下次检定开始日期">
                            </el-date-picker>
          <el-select class="element-list" size="small" clearable :poper-append-to-body="false" popper-class="my-select"
            v-model="searchForm.status" placeholder="请选择在库状态">
            <el-option v-for="item in zkOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
          <el-select class="element-list" size="small" clearable :poper-append-to-body="false" popper-class="my-select"
            v-model="searchForm.states" placeholder="请选择状态">
            <el-option v-for="item in options" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
         
             <el-select class="element-list" size="small" :poper-append-to-body="false" popper-class="my-select" clearable
            v-model="searchForm.isNeedCharge" placeholder="请选择电量状态">
            <el-option v-for="item in incOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
               <el-select class="element-list" size="small" :poper-append-to-body="false" popper-class="my-select" clearable
            v-model="searchForm.assetType" placeholder="请选择资产类型">
            <el-option v-for="item in zcOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
           <el-select class="element-list" size="small" :poper-append-to-body="false" popper-class="my-select" clearable
            v-model="searchForm.storeType" placeholder="请选择存储方式">
            <el-option v-for="item in [{ label: '未绑定位置', key: 1 }, { label: '智能柜', key: 2 }, { label: '货架', key: 3 }]" :key="item.key" :label="item.label" :value="item.key"></el-option>
          </el-select>

          <div  class="my-buttom select-buttom search-button" @click="toSearch">
            查询
          </div>
         

        </div>
        <div style="margin-top: 10px;">
          <div class="my-buttom tit-button" @click="derive">批量导出</div>
          <div class="my-buttom tit-button" @click="deriveLabel">批量导出标签</div>
          <div v-if="yqVal === 1" class="my-buttom tit-button" @click="importInstrumentDemo">仪器导入</div>
          <div class="my-buttom tit-button" @click="derivedInstrument">导出仪器信息</div>
        </div>
      </div>
   
    </div>
    <div class="card-content">
      <div class="warehouse-list">
        <template v-for="(item, index) in btnData">
          <div class="warehouse-item" :class="[ckVal == item.id ? 'select-buttom' : '']" :key="index"
            @click="selectCK(item)">
            {{ item.depotName }}
          </div>
        </template>
        <!-- <div class="warehouse-item selec">新增仓库</div> -->
      </div>
      <div class="comp-conent">
        <component  ref="nstrumentType" :is="comName" :dLoading="dataLoading" @update="selectInsIds"  :vStatus="viewStatus" :dataList="personList" @sChange="sChange"
          @information="information"></component>

        <div class="resource-block" v-if="viewStatus == 0">
          <el-pagination background prev-text="前一页" next-text="后一页" layout="prev, pager, next" :total="total"
            :current-page.sync="currentPage" :page-size="pageSize" @current-change="pageChange"></el-pagination>
        </div>
        <div class="resource-block" v-if="viewStatus == 1">
          <el-pagination background prev-text="前一页" next-text="后一页" layout="sizes, prev, pager, next" :total="total"
            :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizes" @current-change="pageChange"
            @size-change="handleSizeChange"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 各个弹框样式 -->
    <div class="popout model">
      <el-dialog title="新增仪器" center :visible.sync="addModel" width="1000px" :modal-append-to-body="false"
        v-if="addModel" :close-on-click-modal="false">
        <redact-model :yqVal="yqVal" @operation="operation" @cancel="cancel" type="add"></redact-model>
      </el-dialog>
    </div>

    <!-- 仪器导入弹框 -->
    <instrument @closeTitle="importInstrumentVisible = false" :depotId="DepotId" @change="importInstrumentVisible = false; sChange()"
      :importInstrumentVisible="importInstrumentVisible" :uploadUrl="uploadUrl" title="仪器导入"></instrument>

    <!-- 修改视图状态 -->
    <div class="popout model">
      <el-dialog title="修改视图状态" center width="500px" :visible.sync="statusVisible" :close-on-click-modal="false">
        <el-form v-if="statusVisible" :model="ruleForm" status-icon ref="ruleForm" label-width="150px"
          class="demo-ruleForm">
          <el-form-item label="视图类型">
            <el-select style="width: 100%" v-model="ruleForm.status" size="small" placeholder="请选择">
              <el-option label="卡片" :value="0"></el-option>
              <el-option label="表格" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <div class="row-item footer" style="width: 97%; margin-top: 10px; text-align: center">
            <div class="element-list jb-bg btn" @click="submitForm">
              确认
            </div>
            <div class="element-list btn" @click="resetForm">
              取消
            </div>
          </div>
        </el-form>
      </el-dialog>
    </div>
    <!-- 导出标签 -->
    <div class="popout model">
      <el-dialog title="批量导出标签" center :visible.sync="labelVisible" width="900px" :modal-append-to-body="false"
        :close-on-click-modal="false">
        <label-model :labelArray="labelList" :visible.sync="labelVisible" @submit="getLabelParam"
          @closeLable="labelVisible = false"></label-model>
      </el-dialog>
    </div>

  </div>
</template>

<script>
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
//引入仪器和仪器组
import yqComponent from "./components/yq/yqcomponents";
import yqzComponent from "./components/yqz/yqzcomponents";
import gdComponent from "./components/gd/gdcomponents";
import redactModel from "@/components/redactModel";
import labelModel from "@/components/labelModel";

import instrument from "@/views/Instrumentmanagemen/components/instrument.vue";
import {
  getInstrumentPageList,
  batchExportByIns,
  exportExcelv2,
  createInstrument,
  exportLabel
} from "@/api/depotApi";
import { setViewStatus } from "@/api/userApi";
import constants from "@/assets/data/common";
export default {
  data() {
    return {
      searchForm: {}, //搜索
      searchVal: "", //搜索值
      deptId: "", //单位id
      DepotId: "1", //仓库id
      comName: "yqComponent", //当前组件名称
      //分页
      currentPage: 1, //当前页数
      pageSize: 6, //页数
      pageSizes: [10, 20, 50, 100, 200, 500, 1000], //控制每页大小
      total: 0, //总数
      yqVal: 1, //默认选中仪器列表 1：仪器  2：仪器组
      ckVal: 1, //默认显示第一个仓库
      tabVla: 0, //默认不选中
      btnData: [], //仓库数据
      personList: [],
      insIds:[],
      particular: {}, //详细信息
      addModel: false, //新增弹框
      viewStatus: 0, //视图切换标志，0为卡片，1为表格
      dataLoading: true, //数据表加载
      options: constants.options, //状态
      zkOptions: constants.zkOptions, //在库状态
      incOptions: constants.incOptions, //充电状态
      zcOptions: constants.zcOptions, //资产
      labelList: constants.labelList, //资产
      statusVisible: false,
      ruleForm: {},
     
      isOpenPower: false,
      labelVisible: false,

      /** 仪器导入窗口 **/
      importInstrumentVisible: false, //仪器导入框控制
      uploadUrl: "/ims/devOps/importInstrument", //上传地址
      fileList: [],

    };
  },
  components: {
    yqComponent,
    yqzComponent,
    gdComponent,
    redactModel,
    instrument,
    labelModel
  },
  created() {
    this.viewStatus = this.$store.state.user.userInfo.viewStatus || 0;
    this.viewStatus == 0 ? (this.pageSize = 6) : (this.pageSize = 10);
    this.deptId = this.$store.state.user.userInfo.deptId;
    this.btnData = this.$store.state.user.depotList;
    if (this.btnData.length != 0) {
      this.DepotId = this.btnData[0].id;
      this.ckVal = this.DepotId;
    }
    this.$store.commit("setWarehouse", this.DepotId);
    this.$store.commit("setType", this.yqVal);
    this.isOpenPower = this.$store.state.user.modulePower.openPower;
  },
  mounted() {
    if (this.$route.query.isNeedCharge) {
      this.$set(
        this.searchForm,
        "isNeedCharge",
        parseInt(this.$route.query.isNeedCharge)
      );
    }
    this.acquire(this.searchForm);
  },
  methods: {
    selectInsIds(value){
      this.insIds = value

    },
    getLabelParam(data) {
      let objArray = this.labelList.filter((it) => data.some(v => it.key == v))
      const obj = objArray.reduce((res, item, index) => {
        return res[item.key] = item.value, res
      }, {})
      let params = {
        deviceType: this.yqVal || null, //(1 仪器 2 仪器组合 3固定式仪器)
        deptId: this.deptId, //单位
        depotId: this.DepotId, //仓库
        searchInfo: this.searchVal || undefined,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        fields: obj,
        ...this.searchForm,
        calibrationStartDate:this.searchForm.calibration&&this.searchForm.calibration.length?this.searchForm.calibration[0]:'',
        calibrationEndDate:this.searchForm.calibration&&this.searchForm.calibration.length?this.searchForm.calibration[1]:''
      }
      if(this.insIds.length){
        params.insIds = this.insIds
      }
      exportLabel(params).then((res) => {
        console.log(res,'res')
          this.labelVisible = false;
          
          this.mixin.blobDownload(res.data,'仪器设备标签卡.docx');
        })
        .catch((error) => {
          this.mixin.blobErrorTip(error);
        })
        .finally(() => {
          this.labelVisible = false;
        });

    },
    //控制弹框
    importInstrumentDemo() { this.importInstrumentVisible = true; },

    //获取仪器设备列表
    acquire(val) {
      this.dataLoading = true;
      let params = {
        searchInfo: this.searchVal,
        deviceType: this.yqVal ? this.yqVal : null, //(1 仪器 2 仪器组合 3固定式仪器)
        deptId: this.deptId, //单位
        depotId: this.DepotId, //仓库
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        ...val,
        calibrationStartDate:this.searchForm.calibration&&this.searchForm.calibration.length?this.searchForm.calibration[0]:'',
        calibrationEndDate:this.searchForm.calibration&&this.searchForm.calibration.length?this.searchForm.calibration[1]:''
      };
      getInstrumentPageList(params)
        .then((res) => {
          if (res.code == 200) {
            this.$store.dispatch("setUpdateInstr", "false");
            this.personList = res.data.records;
            this.total = res.data.total;
          }
        })
        .finally(() => {
          this.dataLoading = false;
        });


    },
    handleClick(index) {
      this.$router.push({ path: "/employ/maintenance" });
    },
    //选中仓库
    selectCK: function (item) {
      if (item.id != this.ckVal) {
        this.currentPage = 1;
        this.personList = [];
        this.ckVal = item.id;
        this.DepotId = item.id;
        this.$store.commit("setWarehouse", this.DepotId);
        this.searchVal = "";
        if(this.viewStatus==1){
          this.insIds = []
          this.$refs.nstrumentType.clearMultipleSelection()
        }
        this.acquire(this.searchForm);
      }
    },
    yqChange(index) {
      if (index != this.yqVal) {
        this.searchForm = {};
        this.currentPage = 1;
        this.personList = [];
        this.yqVal = index;
        this.searchVal = "";
        this.$store.commit("setType", this.yqVal);
        switch (index) {
          case 0:
            this.comName = "allComponent";
            break;
          case 1:
            this.comName = "yqComponent";
            break;
          case 2:
            this.comName = "yqzComponent";
            break;
          case 3:
            this.comName = "gdComponent";
            break;
          default:
            break;
        }
        this.acquire();
      }
    },
    //判断是否编辑或删除成功后刷新数据
    information() {
      this.currentPage = 1;
      this.acquire();
    },
    //改变转态后刷新数据
    sChange() {
      // this.personList = [];
      this.acquire();
    },
    //分页功能
    pageChange(page) {
      this.currentPage = page;
      this.acquire(this.searchForm);
    },
    handleSizeChange(page) {
      this.pageSize = page;
      this.acquire(this.searchForm);
    },
    //添加仪器
    showModel() {
      this.addModel = true;
    },
    viewChange() {
      let self = this;
      self.personList = [];
      this.currentPage = 1;
      if (self.viewStatus == 0) {
        self.pageSize = 10;
        self.viewStatus = 1;
      } else {
        self.pageSize = 6;
        self.viewStatus = 0;
      }
      self.acquire(self.searchForm);
    },
    operation(data) {
      let params = {
        ...data,
      };
      Object.keys(params).forEach((key) => {
        if (params[key] === "" || params[key] === null) {
          delete params[key];
        }
        if (key === "resultPicFile") {
          delete params[key];
        }
      });
      createInstrument(params)
        .then((res) => {
          if (res.code == "200") {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.acquire();
            this.addModel = false;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error("提交失败，请重新提交");
        });
    },
    cancel() {
      this.addModel = false;
    },
    toSearch() {
      let self = this;
      delay(() => {
        self.currentPage = 1;
        self.personList = [];
        self.acquire(self.searchForm);
      }, 1000);
    },
    setViewStatus() {
      let self = this;
      self.$set(self.ruleForm, "status", parseInt(self.viewStatus));
      self.statusVisible = true;
    },
    submitForm() {
      let self = this;
      let params = {
        id: self.$store.state.user.userInfo.userId,
        ...self.ruleForm,
      };
      setViewStatus(params).then((res) => {
        if (res.code == 200) {
          self.$message({
            type: "success",
            message: "修改成功！",
          });
          self.viewStatus = self.ruleForm.status;
          self.$store.state.user.userInfo.viewStatus = this.viewStatus;
          if (self.viewStatus == 0) {
            self.pageSize = 6;
          } else {
            self.pageSize = 10;
          }
          self.currentPage = 1;
          self.statusVisible = false;
          self.personList = [];
          self.acquire(self.searchForm);
        } else {
          this.$message.error(res.msg || "切换视图失败，请稍后在试！");
        }
      });
    },
    resetForm() {
      let self = this;
      self.statusVisible = false;
    },
    deriveLabel() {
      this.labelVisible = true;
    },
    //导出使用记录
    derive() {
      this.dataLoading = true;
      let params = {
        deviceType: this.yqVal || null, //(1 仪器 2 仪器组合 3固定式仪器)
        deptId: this.deptId, //单位
        depotId: this.DepotId, //仓库
        searchInfo: this.searchVal || undefined,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchForm,
         calibrationStartDate:this.searchForm.calibration&&this.searchForm.calibration.length?this.searchForm.calibration[0]:'',
        calibrationEndDate:this.searchForm.calibration&&this.searchForm.calibration.length?this.searchForm.calibration[1]:''
      };
     
      batchExportByIns(params)
        .then((res) => {
          this.mixin.blobDownload(res.data,'仪器信息.zip');
        })
        .catch((error) => {
          //导出失败时提示后端返回的报错信息
          this.mixin.blobErrorTip(error);
        })
        .finally(() => {
          this.dataLoading = false;
        });
    },
    derivedInstrument(){
      this.dataLoading = true;
      let params = {
        deviceType: this.yqVal || null, //(1 仪器 2 仪器组合 3固定式仪器)
        deptId: this.deptId, //单位
        depotId: this.DepotId, //仓库
        searchInfo: this.searchVal || undefined,
        ...this.searchForm,
        insIds: this.insIds,
         calibrationStartDate:this.searchForm.calibration&&this.searchForm.calibration.length?this.searchForm.calibration[0]:'',
        calibrationEndDate:this.searchForm.calibration&&this.searchForm.calibration.length?this.searchForm.calibration[1]:''
      };
     
      exportExcelv2(params)
        .then((res) => {
          this.mixin.blobDownload(res.data,'仪器信息.xlsx');
        })
        .catch((error) => {
          this.mixin.blobErrorTip(error);
        })
        .finally(() => {
          this.dataLoading = false;
        });
    }
  },
  watch: {
    "$store.state.depot.updateInstr": function (a, b) {
      if (a == "true") {
        this.acquire();
      }
    },
  },
};
</script>

<style lang='less' scoped>
@import "~@/assets/css/commonStyle.less";

.tips {
  background: linear-gradient(180deg,
      rgba(49, 210, 255, 0.52),
      rgba(0, 57, 142, 0.52));
  color: #74c8fe;
}

//按钮样式
.el-button {
  background: url(~@/assets/images/btn.png) no-repeat center;
  background-size: 100% 100%;
  border: none;
  color: #74c8fe;
}

.btn {
  cursor: pointer;
}

//*************************************/

.equip-mana {
  width: 100%;
  color: #74c8fe;

  .head-list {
    display: flex;
    justify-content: space-between;
    padding-left: 187px;
    box-sizing: border-box;

    .search-item {
      width: 100%;
      margin-top: 10px;

      .myinput {
        width: 200px;
      }

      .element-list {
        border: 2px solid #0090f0;
        border-radius: 6px;
        height: 30px;
        width: 150px;
        line-height: 30px;
        text-align: center;

        /deep/ .el-input__inner {
          background-color: rgba(0, 0, 0, 0);
          color: #fff;
          border: 0px;
          border-radius: 0px;
          text-align: center;
        }

        /deep/ input::-webkit-input-placeholder {
          color: #74c8fe;
        }

        /deep/ input::-moz-input-placeholder {
          color: #74c8fe;
        }

        /deep/ input::-ms-input-placeholder {
          color: #74c8fe;
        }
      }
    }
  }

  .card-content {
    display: flex;
    margin-top: 10px;

    .warehouse-list {
      width: 170px;

      .warehouse-item {
        width: 180px;
        border: 2px solid #018be9;
        border-radius: 6px;
        height: 30px;
        line-height: 30px;
        margin-bottom: 15px;
        text-align: center;
        cursor: pointer;
      }
    }

    .comp-conent {
      width: calc(100% - 170px);

      .resource-block {
        margin-top: 10px;
        text-align: center;
      }
    }
  }

  .layouHome {
    height: 100%;
    background-image: url("~@/assets/images/bg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    position: relative;

    //弹框样式
    .popout {
      /deep/.el-form-item {
        border: 2px solid #0090f0;
        border-radius: 6px;
        height: 40px;
        line-height: 40px;
        margin: 20px 0;
        text-align: center;

        .el-form-item__label {
          background-image: linear-gradient(#0479b4, #02407e);
          text-align: center;
          color: #74c8fe;
        }
      }

      .footer {
        display: flex;
        justify-content: center;
        color: #74c8fe;

        .element-list {
          width: 150px;
          cursor: pointer;
          border: 2px solid #0090f0;
          border-radius: 6px;
          height: 30px;
          line-height: 30px;
          margin: 10px 0;
          margin-right: 10px;
          text-align: center;
        }
      }
    }
  }

  // 公共样式
  .selec {
    background-image: linear-gradient(#0479b4, #02407e);
  }
}

.jb-bg {
  background-image: linear-gradient(#0479b4, #02407e);
}

//********************************** */</style>



// WEBPACK FOOTER //
// src/views/Instrumentmanagemen/index.vue